import { createContext, useContext, useState, useMemo, ReactNode } from 'react';

type OperatorExternalIdFallbackContext = {
    operatorExternalIdFallback: string | null;
    setOperatorExternalIdFallback: (operatorExternalId: string | null) => void;
};

const OperatorExternalIdFallbackContextObj =
    createContext<OperatorExternalIdFallbackContext | null>(null);

export function OperatorExternalIdFallbackContextProvider({
    children,
}: {
    children: ReactNode;
}) {
    const [operatorExternalIdFallback, setOperatorExternalIdFallback] =
        useState<string | null>(null);

    const contextValue = useMemo(
        () => ({
            operatorExternalIdFallback,
            setOperatorExternalIdFallback,
        }),
        [operatorExternalIdFallback],
    );

    return (
        <OperatorExternalIdFallbackContextObj.Provider value={contextValue}>
            {children}
        </OperatorExternalIdFallbackContextObj.Provider>
    );
}

export function useOperatorExternalIdFallback(): OperatorExternalIdFallbackContext {
    const context = useContext(OperatorExternalIdFallbackContextObj);
    if (!context) {
        throw new Error(
            'useOperatorExternalIdFallback must be used within a OperatorExternalIdFallbackContextProvider',
        );
    }
    return context;
}
